"use client";

import React from "react";
import PrimaryBtn from "@/components/PrimaryBtn";
import { useScrollToContact } from "@/lib/ScrollUtils";

// Client-side CTA leaf so server-rendered pages don't need "use client" just
// to wire the smooth-scroll handler. Forwards every PrimaryBtn prop except
// onClick; when `dark` is omitted, PrimaryBtn's own default (true) applies.
type ScrollToContactBtnProps = Omit<
  React.ComponentProps<typeof PrimaryBtn>,
  "onClick" | "iconSrc"
> & {
  iconSrc?: React.ComponentProps<typeof PrimaryBtn>["iconSrc"];
};

export default function ScrollToContactBtn({
  iconSrc,
  ...props
}: ScrollToContactBtnProps) {
  const handleSmoothScroll = useScrollToContact();

  return (
    <PrimaryBtn
      {...props}
      iconSrc={iconSrc || ""}
      onClick={() => {
        handleSmoothScroll();
      }}
    />
  );
}
